// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"ub-light_visually-hidden__xIG6c","ub-light":"ub-light_ub-light__qmJds"};